import Add from '@mui/icons-material/Add';
import ListSubheader from '@mui/material/ListSubheader';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';
import useGetUserToken from '../../hooks/useGetUserToken';
import { LoadingIconButton } from '../buttons';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';
import { DEFAULT_OUTLINED_INPUT_CLASS_NAME } from '../../theme/constants/outlined-input';

const GetUserToken = () => {
  const [userId, setUserId, [getUserToken, { loadingGetUserToken }]] = useGetUserToken();
  return (
    <>
      <ListSubheader
        id="nested-list-subheader-log-with-new-user"
        component={Typography}
        variant="h6"
        sx={{ color: 'text.emphasis' }}
      >
        Loguearse como usuario
      </ListSubheader>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ ml: 3 }}>
        <TextField
          variant="outlined"
          name="userIdNewLogged"
          placeholder="Id usuario"
          onChange={(event) => setUserId(event.target.value)}
          InputProps={{
            className: DEFAULT_OUTLINED_INPUT_CLASS_NAME,
          }}
          value={userId}
        />
        <Tooltip title="Loguearse como usuario">
          <LoadingIconButton
            onClick={getUserToken}
            sx={{ p: 0 }}
            loading={loadingGetUserToken}
            size="small"
            color="primary"
          >
            <Add className={DEFAULT_ICON_CLASS_NAME} />
          </LoadingIconButton>
        </Tooltip>
      </Stack>
    </>
  );
};

export default GetUserToken;
